import Card from '../../components/Card'

const project = ({project}) => {
  return (
    <Card className="portfolio__project">
        <div className="portfolio__project-image">
        <img src={project.image} alt="Portfolio Project" />
        </div>
        <h4>{project.title}</h4>
        {project.techStack && (
          <div className="portfolio__project-stack">
            {project.techStack.map((tech) => <span key={tech}>{tech}</span>)}
          </div>
        )}
        <p>{project.desc}</p>
        <div className="portfolio__project-cta">
            {project.website && <a href={project.website} className="btn sm primary" target="_blank" rel="noopener noreferrer">Website</a>}
            {project.demo && <a href={project.demo} className="btn sm" target="_blank" rel="noopener noreferrer">Demo</a>}
            {project.github && <a href={project.github} className="btn sm primary" target="_blank" rel="noopener noreferrer">Github</a>}
        </div>
    </Card>
  )
}

export default project